import { render, staticRenderFns } from "./CDatePicker.vue?vue&type=template&id=2bbb0279&scoped=true&"
import script from "./CDatePicker.vue?vue&type=script&lang=js&"
export * from "./CDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./CDatePicker.vue?vue&type=style&index=0&id=2bbb0279&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb0279",
  null
  
)

export default component.exports